<script>
    import { mapActions } from "vuex";
    import TheSvgIcon from "@main/packages/TheSvgIcon/index.vue";
    import ThePersonalIcon from "@/ThePersonal/components/ThePersonalIcon";

    export default {
        name: "ThePersonalNavigation",
        components: { TheSvgIcon, ThePersonalIcon },
        data() {
            return {
                isOpenedMobileMenu: false,
                menuCurrentTitle: "Личный кабинет",
            };
        },
        computed: {
            routes() {
                return [
                    { title: "Главная", name: "ThePersonalMain", icon: "main" },
                    {
                        title: "Скидки и акции",
                        name: "ThePersonalDiscounts",
                        icon: "discounts",
                    },
                    { title: "Мои данные", name: "ThePersonalData", icon: "data" },
                    { title: "Мои заказы", name: "ThePersonalOrders", icon: "orders" },
                    { title: "Мои адреса", name: "ThePersonalAddresses", icon: "addresses" },
                    { title: "Кешбэк", name: "ThePersonalBonuses", icon: "bonuses" },
                    { title: "Помощь", name: "ThePersonalSupport", icon: "support" },
                ];
            },
        },
        watch: {
            $route(to) {
                const title = this.findMenuTitle(to.name);
                this.setMenuTitle(title);
            },
        },
        mounted() {
            const title = this.findMenuTitle(this.$route.name);
            this.setMenuTitle(title);
        },
        methods: {
            ...mapActions("Profile", ["logoutProfile"]),

            setMenuTitle(title) {
                title === "Главная"
                    ? (this.menuCurrentTitle = "Личный кабинет")
                    : (this.menuCurrentTitle = title);
                this.isOpenedMobileMenu = false;
            },
            findMenuTitle(name) {
                return this.routes.find((route) => name === route.name).title;
            },
            logoutClickHandler() {
                this.logoutProfile().then(() => {
                    this.$router.push({ name: "Home" });
                });
            },
        },
    };
</script>

<template>
    <nav class="the-personal-navigation">
        <div
            class="the-personal-navigation__title"
            :class="{ opened: isOpenedMobileMenu }"
            @click="isOpenedMobileMenu = !isOpenedMobileMenu"
        >
            {{ menuCurrentTitle }}
            <the-svg-icon name="arrow_right" :size-w="24" is-common></the-svg-icon>
        </div>
        <ul class="the-personal-navigation__list" :class="{ opened: isOpenedMobileMenu }">
            <li
                class="the-personal-navigation__item"
                v-for="route in routes"
                :key="route.name"
            >
                <the-personal-icon
                    v-if="route.icon !== 'main'"
                    name="arrow"
                ></the-personal-icon>
                <router-link
                    class="the-personal-navigation__link"
                    :class="{
                        'the-personal-navigation__link--active': $route.name === route.name,
                    }"
                    :to="{ name: route.name }"
                >
                    <img
                        v-if="route.icon === 'discounts'"
                        src="/static/assets/profile/icons/discounts.svg"
                        alt=""
                    />
                    <the-personal-icon v-else :name="route.icon"></the-personal-icon>
                    <span>{{ route.title }}</span>
                </router-link>
            </li>
            <li class="the-personal-navigation__item">
                <button class="the-personal-navigation__link" @click="logoutClickHandler">
                    <the-personal-icon name="exit"></the-personal-icon>
                    <span>Выйти</span>
                </button>
            </li>
        </ul>
    </nav>
</template>

<style lang="scss">
    .the-personal-navigation {
        width: 100%;
        background-color: #fff;
        transition: opacity 0.2s ease-in;
        @include bp($bp-desktop-sm) {
            @include sticky(calc(var(--header-height) + 30px));
            z-index: 12;
            padding: 8px 9px;
            border: $personal-common-border-full;
            border-radius: $personal-box-radius;
            box-shadow: $personal-common-shadow-max;
        }
    }

    .the-personal-navigation__title {
        position: relative;
        z-index: 20;
        padding: 12px 20px 15px;
        color: $personal-title-color;
        font-size: 14px;
        font-weight: $personal-nav-title-weight;
        line-height: 16px;
        background-color: #fff;
        box-shadow: 0 0 30px #f2f2f5;
        transition: box-shadow 0.2s ease-in;
        svg {
            position: absolute;
            top: 50%;
            right: 10px;
            transform: translateY(-50%);
            transition: transform 0.2s ease-in;
        }
        &.opened {
            box-shadow: none;
            svg {
                transform: translateY(-50%) rotate(90deg);
            }
        }
        @include bp($bp-desktop-sm) {
            display: none;
        }
    }

    .the-personal-navigation__list {
        position: absolute;
        left: 0;
        right: 0;
        background-color: #fff;
        overflow: hidden;
        box-shadow: 0 0 30px #d1d3e3;
        transform: translateY(-150%);
        transition: transform 0.3s ease-in;
        &.opened {
            transform: translateY(0);
        }
        @include bp($bp-desktop-sm) {
            position: static;
            box-shadow: none;
            border-radius: $personal-box-radius;
            transform: translateY(0);
        }
    }

    .the-personal-navigation__item {
        position: relative;
        svg.icon-arrow {
            position: absolute;
            top: 50%;
            right: 20px;
            width: 12px;
            height: 12px;
            fill: $personal-active-color;
            transform: translateY(-50%);
        }
        &:last-child {
            .the-personal-navigation__link {
                position: relative;
                &::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    right: 10px;
                    left: 10px;
                    height: 1px;
                    background: $personal-divider-gradient;
                }
            }
        }

        @include bp($bp-desktop-sm) {
            svg.icon-arrow {
                display: none;
            }
        }
    }

    .the-personal-navigation__link {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 12px 20px;
        color: $personal-nav-color;
        font-family: $personal-nav-font;
        font-size: $personal-nav-size;
        font-weight: $personal-nav-weight;
        line-height: 20px;
        text-transform: $personal-nav-case;
        transition: background-color 0.2s ease-in, color 0.2s ease-in;
        -webkit-tap-highlight-color: transparent;
        user-select: none;
        svg,
        img {
            width: 16px;
            height: 16px;
            margin-right: 10px;
            fill: $personal-nav-color;
            stroke: $personal-nav-color;
            transition: fill 0.2s ease-in, stroke 0.2s ease-in;
        }
        @include bp($bp-desktop-sm) {
            padding: 12px;
            border-radius: $personal-nav-radius;
            &:focus-visible {
                @include outline(-2px);
            }
            &:hover {
                background-color: $personal-nav-fill;
            }
        }
    }

    .the-personal-navigation__link--active {
        color: $personal-nav-color--active;
        background-color: $personal-nav-fill;
        svg {
            fill: $personal-nav-color--active;
            stroke: $personal-nav-color--active;
        }
    }
</style>
